import * as i0 from '@angular/core';
import { EventEmitter, Directive, Output, Input, NgModule, HostListener, Injectable, InjectionToken, PLATFORM_ID, Inject, Component } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DecimalPipe, isPlatformBrowser, DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

class InViewportDirective {
    constructor(element) {
        this.element = element;
        this.fstrInViewport = new EventEmitter(null);
        this.delay = 500;
        this.once = true;
        this.threshold = 0;
        this._isIntersecting = false;
    }
    ngAfterViewInit() {
        if (typeof window !== 'undefined' && window['IntersectionObserver'] !== undefined) {
            setTimeout(() => {
                const callback = e => {
                    if (e[0].isIntersecting) {
                        this._isIntersecting = true;
                        this.fstrInViewport.emit(this._isIntersecting);
                        if (this.once) {
                            observer.disconnect();
                        }
                    }
                    else if (this._isIntersecting && !e[0].isIntersecting) {
                        this._isIntersecting = false;
                        this.fstrInViewport.emit(this._isIntersecting);
                    }
                };
                const observer = new IntersectionObserver(callback, {
                    threshold: [this.threshold],
                });
                observer.observe(this.element.nativeElement);
            }, this.delay);
        }
    }
}
InViewportDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: InViewportDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
InViewportDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.1.3", type: InViewportDirective, selector: "[fstrInViewport]", inputs: { delay: "delay", once: "once", threshold: "threshold" }, outputs: { fstrInViewport: "fstrInViewport" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: InViewportDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fstrInViewport]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { fstrInViewport: [{
                type: Output
            }], delay: [{
                type: Input
            }], once: [{
                type: Input
            }], threshold: [{
                type: Input
            }] } });

class InViewModule {
}
InViewModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: InViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
InViewModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: InViewModule, declarations: [InViewportDirective], imports: [CommonModule], exports: [InViewportDirective] });
InViewModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: InViewModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: InViewModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [InViewportDirective],
                    exports: [InViewportDirective],
                    imports: [CommonModule],
                }]
        }] });

class CountDirective {
    constructor(element, decimalPipe) {
        this.element = element;
        this.decimalPipe = decimalPipe;
        this.from = 0;
        this.countStart = false;
        this.decimals = 0;
        this.framerate = 66;
        this.time = 1500;
        this.steps = this.time / this.framerate;
    }
    ngAfterViewInit() {
        this.reset();
    }
    ngOnChanges(changes) {
        changes && changes['countStart'] && changes['countStart'].currentValue === true ? this.start() : this.reset();
    }
    reset() {
        this.element.nativeElement.innerHTML = 0;
    }
    start() {
        const valToAnimate = this.fstrCount - this.from;
        for (let i = 0; i <= this.steps; i++) {
            const delay = i * this.framerate;
            const factor = delay / this.time;
            // tslint:disable-next-line:max-line-length
            const formatedNumber = this.decimalPipe.transform(parseFloat((this.from + factor * valToAnimate)).toFixed(this.decimals));
            setTimeout(() => (this.element.nativeElement.innerHTML = formatedNumber), delay);
        }
        setTimeout(() => (this.element.nativeElement.innerHTML = this.decimalPipe.transform(parseFloat(this.fstrCount))), this.time);
    }
}
CountDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountDirective, deps: [{ token: i0.ElementRef }, { token: i1.DecimalPipe }], target: i0.ɵɵFactoryTarget.Directive });
CountDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.1.3", type: CountDirective, selector: "[fstrCount]", inputs: { fstrCount: "fstrCount", from: "from", countStart: "countStart", decimals: "decimals" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fstrCount]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.DecimalPipe }]; }, propDecorators: { fstrCount: [{
                type: Input
            }], from: [{
                type: Input
            }], countStart: [{
                type: Input
            }], decimals: [{
                type: Input
            }] } });

class CountToModule {
}
CountToModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountToModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CountToModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountToModule, declarations: [CountDirective], imports: [CommonModule], exports: [CountDirective] });
CountToModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountToModule, providers: [DecimalPipe], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountToModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CountDirective],
                    exports: [CountDirective],
                    imports: [CommonModule],
                    providers: [DecimalPipe],
                }]
        }] });

class ScrollToDirective {
    constructor() {
        this.fstrScrollTo = 0;
    }
    scrollToY(scrollTargetY = this.fstrScrollTo, speed = 2000, easing = 'easeOutSine') {
        scrollToY(this.fstrScrollTo, speed, easing);
    }
}
ScrollToDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ScrollToDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ScrollToDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.1.3", type: ScrollToDirective, selector: "[fstrScrollTo]", inputs: { fstrScrollTo: "fstrScrollTo" }, host: { listeners: { "click": "scrollToY()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ScrollToDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[fstrScrollTo]',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { fstrScrollTo: [{
                type: Input
            }], scrollToY: [{
                type: HostListener,
                args: ['click']
            }] } });
function scrollToY(scrollTargetY = 0, speed = 2000, easing = 'easeOutSine') {
    let currentTime = 0;
    const scrollY = window.scrollY;
    const time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8));
    const PI_D2 = Math.PI / 2;
    const easingEquations = {
        easeOutSine: pos => Math.sin(pos * (Math.PI / 2)),
        easeInOutSine: pos => -0.5 * (Math.cos(Math.PI * pos) - 1),
        easeInOutQuint: pos => {
            if ((pos /= 0.5) < 1) {
                return 0.5 * Math.pow(pos, 5);
            }
            return 0.5 * (Math.pow(pos - 2, 5) + 2);
        },
    };
    function tick() {
        currentTime += 1 / 60;
        const p = currentTime / time;
        const t = easingEquations[easing](p);
        if (p < 1) {
            requestAnimationFrame(tick);
            window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
        }
        else {
            // console.log('scroll done');
            window.scrollTo(0, scrollTargetY);
        }
    }
    tick();
}

class ScrollToModule {
}
ScrollToModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ScrollToModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ScrollToModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ScrollToModule, declarations: [ScrollToDirective], imports: [CommonModule], exports: [ScrollToDirective] });
ScrollToModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ScrollToModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ScrollToModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ScrollToDirective],
                    exports: [ScrollToDirective],
                    imports: [CommonModule],
                }]
        }] });

class BreakpointService {
    constructor() { }
    /* Read css properties of elements */
    getPseudoProperty(el, pseudo, prop) {
        const value = window
            .getComputedStyle(document.querySelector(el), pseudo)
            .getPropertyValue(prop)
            .replace(/^["']|["']$/g, '');
        return value;
    }
    /* Return css breakpoint */
    getBreakpoint() {
        return this.getPseudoProperty('body', ':after', 'content');
    }
}
BreakpointService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BreakpointService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BreakpointService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BreakpointService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BreakpointService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class BreakpointsModule {
    static forRoot(config) {
        return {
            ngModule: BreakpointsModule,
            providers: [BreakpointService],
        };
    }
}
BreakpointsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BreakpointsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BreakpointsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BreakpointsModule, imports: [CommonModule] });
BreakpointsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BreakpointsModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BreakpointsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule],
                }]
        }] });

/**
 * This is not a real service, but it looks like it from the outside.
 * It's just an InjectionTToken used to import the config object, provided from the outside
 */
const DarkModeConfigService = new InjectionToken('DarkModeConfig');

class DarkmodeService {
    constructor(document, platformId, config) {
        this.document = document;
        this.platformId = platformId;
        this.config = config;
        //  public renderer: Renderer2;
        this.currentMode = {
            dark: true,
            type: 'auto',
        };
        this.currentMode$ = new BehaviorSubject(this.currentMode);
        // check if client
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        if (!this.userMode.exp) {
            this.checkColorScheme();
            this.setAutoListener();
            // window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => this.checkColorScheme());
        }
        else {
            this.checkType();
        }
    }
    get userMode() {
        const pref = JSON.parse(localStorage.getItem('dark_mode'));
        if (!pref) {
            return false;
        }
        return {
            type: pref.type,
            exp: Date.now() < pref.exp,
        };
    }
    setAutoListener() {
        const darkMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        try {
            // Chrome & Firefox
            darkMediaQuery.addEventListener('change', e => {
                this.checkColorScheme();
            });
        }
        catch (e1) {
            try {
                // Safari
                darkMediaQuery.addListener(e => {
                    this.checkColorScheme();
                });
            }
            catch (e2) {
                console.error(e2);
            }
        }
    }
    checkType() {
        this.currentMode.type = this.userMode.type;
        switch (this.userMode.type) {
            case 'light':
                this.SetDisplayMode(false);
                break;
            case 'dark':
                this.SetDisplayMode(true);
                break;
            case 'auto':
                this.checkColorScheme();
                this.setAutoListener();
                break;
        }
    }
    SetDisplayMode(dark) {
        // this.darkMode = bool;
        this.currentMode.dark = dark;
        this.currentMode$.next(this.currentMode);
        if (dark) {
            this.document.querySelector('body').classList.remove(this.config.light.bodyClass);
            this.document.querySelector('body').classList.add(this.config.dark.bodyClass);
        }
        else {
            this.document.querySelector('body').classList.remove(this.config.dark.bodyClass);
            this.document.querySelector('body').classList.add(this.config.light.bodyClass);
        }
    }
    setUserPreference(type) {
        const expTime = 86400 * 1 * 1000 + Date.now(); // localstorage 24h
        // console.log(type);
        localStorage.setItem('dark_mode', JSON.stringify({ exp: expTime, type: type })); // set localstorage
        this.checkType();
    }
    checkColorScheme() {
        const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const isLightMode = window.matchMedia('(prefers-color-scheme: light)').matches;
        const isNotSpecified = window.matchMedia('(prefers-color-scheme: no-preference)').matches;
        const hasNoSupport = !isDarkMode && !isLightMode && !isNotSpecified;
        let colorMode = false;
        // fallback not supported browsers
        if (hasNoSupport) {
            const now = new Date();
            const hour = now.getHours();
            if (hour < 7 || hour >= 19) {
                // this.darkMode = true;
                colorMode = true;
            }
        }
        else if (isDarkMode) {
            // this.darkMode = true;
            colorMode = true;
        }
        else if (isLightMode) {
            // this.darkMode = false;
            colorMode = false;
        }
        // console.log('auto');
        this.SetDisplayMode(colorMode);
    }
}
DarkmodeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DarkmodeService, deps: [{ token: DOCUMENT }, { token: PLATFORM_ID }, { token: DarkModeConfigService }], target: i0.ɵɵFactoryTarget.Injectable });
DarkmodeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DarkmodeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DarkmodeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [PLATFORM_ID]
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [DarkModeConfigService]
                    }] }];
    } });

class DarkModeSwitchComponent {
    constructor(darkModeService) {
        this.darkModeService = darkModeService;
    }
    ngOnInit() {
        this.darkModeService.currentMode$.subscribe(d => {
            this.displayMode = d;
        });
    }
    changeColorMode(e) {
        this.darkModeService.setUserPreference(e.target.value);
    }
}
DarkModeSwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DarkModeSwitchComponent, deps: [{ token: DarkmodeService }], target: i0.ɵɵFactoryTarget.Component });
DarkModeSwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: DarkModeSwitchComponent, selector: "fstr-dark-mode-switch", ngImport: i0, template: "<div class=\"darkmode-switch\">\r\n  <input\r\n    id=\"DarkMode\"\r\n    type=\"radio\"\r\n    (change)=\"changeColorMode($event)\"\r\n    name=\"darkmode\"\r\n    value=\"dark\"\r\n    [checked]=\"displayMode.type === 'dark'\"\r\n  />\r\n  <label class=\"darkmode-switch__item\" for=\"DarkMode\"><span>Dark</span></label>\r\n  <input\r\n    id=\"AutoMode\"\r\n    type=\"radio\"\r\n    (change)=\"changeColorMode($event)\"\r\n    name=\"darkmode\"\r\n    value=\"auto\"\r\n    [checked]=\"displayMode.type === 'auto'\"\r\n  />\r\n  <label class=\"darkmode-switch__item\" for=\"AutoMode\"><span>Auto</span></label>\r\n  <input\r\n    id=\"LightMode\"\r\n    type=\"radio\"\r\n    (change)=\"changeColorMode($event)\"\r\n    name=\"darkmode\"\r\n    value=\"light\"\r\n    [checked]=\"displayMode.type === 'light'\"\r\n  />\r\n  <label class=\"darkmode-switch__item\" for=\"LightMode\"><span>Light</span></label>\r\n  <span class=\"darkmode-switch__btn\"></span>\r\n</div>\r\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DarkModeSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fstr-dark-mode-switch', template: "<div class=\"darkmode-switch\">\r\n  <input\r\n    id=\"DarkMode\"\r\n    type=\"radio\"\r\n    (change)=\"changeColorMode($event)\"\r\n    name=\"darkmode\"\r\n    value=\"dark\"\r\n    [checked]=\"displayMode.type === 'dark'\"\r\n  />\r\n  <label class=\"darkmode-switch__item\" for=\"DarkMode\"><span>Dark</span></label>\r\n  <input\r\n    id=\"AutoMode\"\r\n    type=\"radio\"\r\n    (change)=\"changeColorMode($event)\"\r\n    name=\"darkmode\"\r\n    value=\"auto\"\r\n    [checked]=\"displayMode.type === 'auto'\"\r\n  />\r\n  <label class=\"darkmode-switch__item\" for=\"AutoMode\"><span>Auto</span></label>\r\n  <input\r\n    id=\"LightMode\"\r\n    type=\"radio\"\r\n    (change)=\"changeColorMode($event)\"\r\n    name=\"darkmode\"\r\n    value=\"light\"\r\n    [checked]=\"displayMode.type === 'light'\"\r\n  />\r\n  <label class=\"darkmode-switch__item\" for=\"LightMode\"><span>Light</span></label>\r\n  <span class=\"darkmode-switch__btn\"></span>\r\n</div>\r\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: DarkmodeService }]; } });

class DarkModeModule {
    static forRoot(config) {
        let defaultConfig = {
            auto: { bodyClass: '' },
            light: { bodyClass: 'light--mode' },
            dark: { bodyClass: 'dark--mode' },
        };
        defaultConfig = Object.assign(defaultConfig, config);
        return {
            ngModule: DarkModeModule,
            providers: [
                {
                    provide: DarkModeConfigService,
                    useValue: defaultConfig,
                },
                DarkmodeService,
            ],
        };
    }
}
DarkModeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DarkModeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DarkModeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DarkModeModule, declarations: [DarkModeSwitchComponent], imports: [CommonModule], exports: [DarkModeSwitchComponent] });
DarkModeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DarkModeModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DarkModeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DarkModeSwitchComponent],
                    imports: [CommonModule],
                    exports: [DarkModeSwitchComponent],
                }]
        }] });

class StringUtility {
    static StripHTML(value) {
        if (typeof window !== 'undefined') {
            const element = document.createElement('div');
            element.innerHTML = value;
            return element.innerText;
        }
        else {
            return value;
        }
    }
    static UrlRewrite(value) {
        if (typeof value !== 'string') {
            return '';
        }
        return value
            .replace(/ /g, '-')
            .replace(/&/g, 'en')
            .replace(/!/g, '')
            .replace(/\./g, '')
            .replace(/,/g, '')
            .replace(/\?/g, '')
            .replace(/\+/g, '')
            .toLowerCase();
    }
    static Truncate(value, limit = 140, endsWith = '...') {
        return value.length > limit ? value.substring(0, limit - endsWith.length) + endsWith : value;
    }
}

/*
 * Public API Surface of utility
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BreakpointService, BreakpointsModule, CountDirective, CountToModule, DarkModeModule, DarkModeSwitchComponent, DarkmodeService, InViewModule, InViewportDirective, ScrollToDirective, ScrollToModule, StringUtility, scrollToY };
